<template>
  <b-icon :icon="genderedIcon" :type="genderedColors" size="is-small"></b-icon>
</template>

<script>
export default {
  props: {
    genderCode: {
      type: String,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    genderedIcon () {
      return this.genderCode.toLowerCase() === 'm' ? 'gender-male' : 'gender-female'
    },
    genderedColors () {
      return this.genderCode.toLowerCase() === 'm' ? 'is-info' : 'is-danger'
    }
  }
}
</script>
